module.exports = __webpack_public_path__ + "static/media/chrome_menu.f14fab42.svg";